import React from 'react';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';

const StyledTypography = styled(
  Typography,
  { shouldForwardProp: (p) => p !== 'overlay' },
)(({ theme, overlay }) => ({
  position: overlay ? 'absolute' : 'relative',
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'center',
  padding: theme.spacing(1),
  background: `${theme.palette.grey[900]}80`,
  color: theme.palette.common.white,
  bottom: 0,
}));

function Caption(props) {
  const { children, overlay = false } = props;
  return (
    <StyledTypography variant='body1' component='div' overlay={overlay}>{children}</StyledTypography>
  );
}

export default Caption;
